import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./index.css";
import { I18nProvider } from "./i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingActions from "./components/FloatingActions";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import Company from "./pages/Company";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Services from "./pages/Services";
import { BlogList, BlogPost } from "./pages/Blog";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import EstimatePay from "./pages/EstimatePay";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function ScrollTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => { if (!hash) window.scrollTo(0, 0); }, [pathname, hash]);
  return null;
}

function Loader() {
  const [off, setOff] = useState(false);
  useEffect(() => { const t = setTimeout(() => setOff(true), 700); return () => clearTimeout(t); }, []);
  return (
    <div className={`loader ${off ? "off" : ""}`}>
      <div>
        <div className="mark">GRUPO INVERSIONES ALTAMIRA</div>
        <div className="bar"><i /></div>
      </div>
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Loader />
        <ScrollTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/empresa" element={<Company />} />
            <Route path="/catalogo" element={<Catalog />} />
            <Route path="/catalogo/:slug" element={<ProductDetail />} />
            <Route path="/servicios" element={<Services />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/presupuesto/:id" element={<EstimatePay />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
        <ChatWidget />
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
